import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { AuthService } from '@auth0/auth0-angular';
import { environment } from '../../../../environments/environment';
import { AuthHeaderComponent } from '../../../shared/ui/auth-layout/auth-header.component';
import { AuthFooterComponent } from '../../../shared/ui/auth-layout/auth-footer.component';
import { ProfileService } from '../../../core/services/profile.service';

interface ComparisonFeature {
  name: string;
  free: boolean | string;
  yardie: boolean | string;
  dondada: boolean | string;
}

@Component({
  selector: 'app-pricing-page',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    ToggleSwitchModule,
    TableModule,
    AccordionModule,
    AuthHeaderComponent,
    AuthFooterComponent,
  ],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingPageComponent {
  private route = inject(ActivatedRoute);
  private auth = inject(AuthService);
  private profileService = inject(ProfileService);

  pricingTableId = environment.stripe_pricing_table_id;
  publishableKey = environment.stripe_publishable_key;
  customerEmail = signal<string>('');

  plan = signal<string | null>(null);
  feature = signal<string | null>(null);
  required = signal<string | null>(null);

  // CONSTRUCTOR
  constructor() {
    this.route.queryParamMap.subscribe(params => {
      this.plan.set(params.get('plan'));
      this.feature.set(params.get('feature'));
      this.required.set(params.get('required'));
    });

    // Fetch user profile and set customer email
    this.profileService.getUserProfile().subscribe(profile => {
      this.customerEmail.set(profile.email);
    });
  }

  onBillingToggle() {
    // Toggle handled by ngModel binding
  }

   upgradeMode() {
    return this.feature() !== null && this.required() !== null;
  }

  selectPlan(plan: string) {
    // If user not logged in → login then redirect back
    const sub = this.auth.isAuthenticated$.subscribe(loggedIn => {
      if (!loggedIn) {
        this.auth.loginWithRedirect({
          appState: {
            target: `/pricing?plan=${plan}`
          }
        });
        sub.unsubscribe();
        return;
      }

      // Logged in, but Stripe not wired yet
      // alert(`Upgrade to ${plan} will be implemented soon.`);
      sub.unsubscribe();
    });
  }
}
